module.exports = __webpack_public_path__ + "img/signs1_4.6f5472ce.jpg";